import LocalizedStrings from 'localized-strings';

const errorMessages = new LocalizedStrings({
  en: {
    unexpectedShineStartChoice:
      'Please select the "Create a micro-entreprise" option from the previous page',
  },

  fr: {
    unexpectedShineStartChoice:
      'Veuillez sélectionner l\'option "Créer une micro-entreprise" dans la page précédente',
  },
} as const);

export default errorMessages;
